"use client";
import { useRef, useState } from "react";
import { usePathname } from "next/navigation";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Navbar from "./Navbar";
import TeamInviteNoticeBar from "../team/TeamInviteNoticeBar";
import OrganizerInviteCard from "../team/OrganizerInviteCard";

const NavbarWrapper = () => {
  const navbarRef = useRef();
  const pathname = usePathname();
  const theme = useTheme();
  const isSmOrSmaller = useMediaQuery(theme.breakpoints.down("md"), {
    // Keep first client render aligned with SSR output to avoid hydration mismatches.
    noSsr: true,
    defaultMatches: false,
  });
  const isAuthPage = pathname.startsWith("/auth");
  const [webcamOpen, setWebcamOpen] = useState(false);

  const isAnonymousSharePage = pathname.startsWith("/share/");
  const shouldHideNavbar = isAnonymousSharePage || (!isSmOrSmaller && isAuthPage);

  return (
    <>
      {!shouldHideNavbar && (
        <Box
          sx={{
            minWidth: 0,
            maxWidth: "100%",
            width: "100%",
          }}
        >
          <Navbar
            ref={navbarRef}
            color="primary"
            webcamOpen={webcamOpen}
            setWebcamOpen={setWebcamOpen}
          />
        </Box>
      )}
      {!isAnonymousSharePage && <OrganizerInviteCard />}
      {!isAnonymousSharePage && <TeamInviteNoticeBar />}
    </>
  );
};

export default NavbarWrapper;
